import React, { useState } from 'react';

function SettingsRow({ title, description, control }) {
  return (
    <div className="settings-row">
      <div className="settings-row-info">
        <h3 className="settings-row-title">{title}</h3>
        {description && <p className="settings-row-desc">{description}</p>}
      </div>
      <div className="settings-row-control">{control}</div>
    </div>
  );
}

function SettingsView({ theme, onToggleTheme, onSetTheme, onBack, canInstallApp, onInstallApp, onLogout }) {
  const [notificationsEnabled, setNotificationsEnabled] = useState(true);
  const [remindersEnabled, setRemindersEnabled] = useState(false);

  return (
    <div className="screen settings-screen">
      <section className="section">
        <header className="settings-header">
          <button type="button" className="settings-back" onClick={onBack} aria-label="Volver">
            ← Atrás
          </button>
          <div className="settings-header-text">
            <h1 className="title">Configuración</h1>
            <p className="subtitle">Personaliza cómo quieres usar Sportivos.</p>
          </div>
        </header>
        <div className="settings-card">
          <h2 className="settings-section-title">Apariencia</h2>
          <SettingsRow
            title="Tema de la aplicación"
            description="El modo oscuro es el predeterminado."
            control={(
              <div className="settings-theme-options" role="group" aria-label="Seleccionar tema">
                <button
                  type="button"
                  className={theme === 'dark' ? 'settings-option settings-option-active' : 'settings-option'}
                  onClick={() => onSetTheme('dark')}
                >
                  🌙 Oscuro
                </button>
                <button
                  type="button"
                  className={theme === 'light' ? 'settings-option settings-option-active' : 'settings-option'}
                  onClick={() => onSetTheme('light')}
                >
                  🌞 Claro
                </button>
              </div>
            )}
          />
          <button
            type="button"
            className="settings-link"
            onClick={onToggleTheme}
            aria-label="Invertir tema"
          >
            Alternar rápido
          </button>
        </div>
      </section>

      <section className="section">
        <div className="settings-card">
          <h2 className="settings-section-title">Notificaciones</h2>
          <SettingsRow
            title="Recordatorios push"
            description="Recibe avisos cuando tus sesiones estén por comenzar."
            control={(
              <button
                type="button"
                className={notificationsEnabled ? 'settings-toggle settings-toggle-on' : 'settings-toggle'}
                onClick={() => setNotificationsEnabled((prev) => !prev)}
                aria-pressed={notificationsEnabled}
              >
                <span>{notificationsEnabled ? 'Activado' : 'Desactivado'}</span>
              </button>
            )}
          />
          <SettingsRow
            title="Resúmenes semanales"
            description="Un correo con tu progreso y nuevas metas."
            control={(
              <button
                type="button"
                className={remindersEnabled ? 'settings-toggle settings-toggle-on' : 'settings-toggle'}
                onClick={() => setRemindersEnabled((prev) => !prev)}
                aria-pressed={remindersEnabled}
              >
                <span>{remindersEnabled ? 'Activado' : 'Desactivado'}</span>
              </button>
            )}
          />
        </div>
      </section>

      {canInstallApp && (
        <section className="section">
          <div className="settings-card settings-card-highlight">
            <div className="settings-install" role="presentation">
              <div className="settings-install-info">
                <span className="settings-install-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" focusable="false">
                    <path
                      d="M7.25 2.75h9.5a1.5 1.5 0 0 1 1.5 1.5v15.5a1.5 1.5 0 0 1-1.5 1.5h-9.5a1.5 1.5 0 0 1-1.5-1.5V4.25a1.5 1.5 0 0 1 1.5-1.5Zm4.75 15.5a1.05 1.05 0 1 0 0 2.1 1.05 1.05 0 0 0 0-2.1Zm3.25-14.1H8.75v11.2h6.5Z"
                    />
                  </svg>
                </span>
                <div>
                  <h2 className="settings-section-title">Instala Sportivos</h2>
                  <p className="settings-section-desc">Accede más rápido desde tu pantalla de inicio y recibe notificaciones sin abrir el navegador.</p>
                </div>
              </div>
              <button
                type="button"
                className="pill-button pill-button-primary"
                onClick={onInstallApp}
              >
                Instalar aplicación
              </button>
            </div>
          </div>
        </section>
      )}

      <section className="section">
        <div className="settings-card">
          <h2 className="settings-section-title">Preferencias por defecto</h2>
          <ul className="settings-list">
            <li>
              <span>Idioma</span>
              <strong>Español</strong>
            </li>
            <li>
              <span>Zona horaria</span>
              <strong>GMT-3 Santiago</strong>
            </li>
            <li>
              <span>Recordatorios diarios</span>
              <strong>08:00 hrs</strong>
            </li>
          </ul>
        </div>
      </section>

      <section className="section">
        <div className="settings-card settings-card-danger">
          <div className="settings-logout">
            <div className="settings-logout-info">
              <h2 className="settings-section-title">Cuenta</h2>
              <p className="settings-section-desc">Cierra tu sesión actual para usar Sportivos en otro dispositivo o con un perfil distinto.</p>
            </div>
            <button type="button" className="pill-button pill-button-danger" onClick={onLogout}>
              Cerrar sesión
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SettingsView;
